module.exports = __webpack_public_path__ + "static/jerome_loremipsum-db6582618bfcfbe57027a1e0a0868190.png";